/*
 * Copyright ©2020. Open Digital Solutions, Novi Sad. Sva prava zadržana.
 * Pravo da se koristi, kopira, modifikuje i distribuira ovaj softver i njegova dokumentacija
 * u bilo koje svrhe, bez naknade ili bez potpisanog sporazuma sa vlasnikom softvera, nije dozvoljeno.
 */

import { Injectable, OnInit } from '@angular/core';
import * as Stomp from 'stompjs';
import * as SockJS from 'sockjs-client';
import { AppService } from './app.service';
import { environment } from 'src/environments/environment';
import { DataSharingService } from './data-sharing.service';
import { LocalStorageService } from 'src/app/local-storage.service';

@Injectable({
   providedIn: 'root',
})
export class WebsocketService implements OnInit {
   private stompClient;
   private loggedIn;

   constructor(
      private appService: AppService,
      private dataService: DataSharingService,
      private localStorageService: LocalStorageService,
   ) {}

   // tslint:disable-next-line: contextual-lifecycle
   ngOnInit(): void {}

   initializeWebSocketConnection(user) {
      const ws = new SockJS(this.appService.getUrlNotifications() + environment.websocketUrl);
      this.stompClient = Stomp.over(ws);
      this.stompClient.debug = null;
      this.loggedIn = JSON.parse(this.localStorageService.get('loggedUser'));
      let that = this;
      this.stompClient.connect({}, function (frame) {
         that.stompClient.subscribe('/user/' + that.loggedIn.id + '/msg', (message: { body: string }) => {
            if (message.body) {
               const body = JSON.parse(message.body);
               if (body.type === 'INTERNAL') {
                  if (body.internalType === 'SOLUTION' || body.internalType === 'SIDE_TEMPLATE') {
                     that.dataService.internalNotification.next(body);
                  } else {
                     let documentName: string;
                     if (body.internalType === 'VS_PP') {
                        documentName = environment.vsDocumentPP;
                     } else if (body.internalType === 'VS_PU') {
                        documentName = environment.vsDocumentPU;
                     } else if (body.internalType === 'VS_CLOSURE') {
                        documentName = environment.vsDocumentZakljucak;
                     }
                     const data = { caseId: body.socialCaseId, document: documentName };
                     that.dataService.documentSigned.next(data);
                  }
               } else {
                  if (body.type === 'NEW_DOCUMENT') {
                     that.dataService.newDocument.next(true);
                  }
                  if (body.type === 'PMN_CASE') {
                     that.dataService.pmnCases.next(true);
                     that.dataService.notifications.next('GENERAL');
                  }
                  if (body.type === 'CASES') {
                     that.dataService.cases.next(true);
                  }
                  if (body.type === 'UNASSIGNED') {
                     that.dataService.newCase.next(true);
                  }
                  if (body.type === 'SUBMISSIONS') {
                     that.dataService.newSubmission.next(true);
                  }
                  that.dataService.notifications.next(body.type);
               }
            }
         });
      });
   }
}
